// hack to let us reference cs vars from JS
const styleguideVars = require('!!sass-to-js-var-loader!lib/styleguide/variables.scss') // eslint-disable-line
export { styleguideVars }
